import { useMemo } from "react";
import {
  CartesianGrid, Line, LineChart, Tooltip, XAxis, YAxis,
} from "recharts";
import { CockpitPanel } from "@/cockpit/CockpitPanel";
import { FixedChart } from "@/cockpit/FixedChart";
import { downsampleSeries } from "@/cockpit/downsample";
import { AXIS, GRID, SENT, fmtMd, tooltipBox } from "@/cockpit/formatCockpit";

export function SentimentAdvanceDeclineChart({ series }) {
  const data = useMemo(() => downsampleSeries(series || [], 500), [series]);
  return (
    <CockpitPanel
      title="Sentiment advance / decline"
      hint="Among the mock large-cap set. ▲ advances minus ▼ declines, cumulative."
      testid="sentiment-advance-decline"
    >
      <FixedChart height={140}>
        {(width) => (
          <LineChart width={width} height={140} data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid stroke={GRID} strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="date" tick={{ fill: AXIS, fontSize: 9 }} tickFormatter={fmtMd} minTickGap={28} />
            <YAxis tick={{ fill: AXIS, fontSize: 9 }} width={36} />
            <Tooltip
              contentStyle={tooltipBox}
              formatter={(v, name) => [v, name === "line" ? "A/D line" : name]}
              labelFormatter={fmtMd}
            />
            <Line dataKey="line" name="A/D line" stroke={SENT} dot={false} strokeWidth={1.5} isAnimationActive={false} />
          </LineChart>
        )}
      </FixedChart>
    </CockpitPanel>
  );
}
